'use client';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { Box, keyframes } from '@mui/material';
import { useContext } from 'react';

const drawPath = keyframes`
  from {
    stroke-dashoffset: 1302;
  }
  to {
    stroke-dashoffset: 0;
  }
`;

// LoadingFallback组件
export const Loading = () => {
  const { deviceType } = useContext(ResponsiveContext);

  return (
    <Box
      className="loading-container"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        zIndex: 9990,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          height: deviceType === EPlatform.WEB ? '103px' : '22px',
          width: deviceType === EPlatform.WEB ? '300px' : '161px',
          left: '50%',
          top: '50%',
          transform: 'translateX(-50%) translateY(-50%)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '& .logo-loading-bg': {
            height: deviceType === EPlatform.WEB ? '103px' : '22px',
            width: deviceType === EPlatform.WEB ? '300px' : '161px',
          },
          '& .logo-main-path': {
            position: 'absolute',
            top: deviceType === EPlatform.WEB ? '31px' : '-0.7px',
            height: deviceType === EPlatform.WEB ? '42px' : '23px',
            width: deviceType === EPlatform.WEB ? '98px' : '53px',
            left: deviceType === EPlatform.WEB ? '164px' : '87.7px',
          },
          '& .logo-main-path path': {
            fill: 'none',
            stroke: '#282828',
            strokeWidth: '18',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: '1302',
            strokeDashoffset: '1302',
            animation: `${drawPath} 1.5s ease-in-out infinite alternate`,
          },
        }}
      >
        <svg
          className="logo-loading-bg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 757 103"
          fill="none"
        >
          <path
            d="M100.873 15.9509V13.2194C100.873 8.43073 97.1974 4.54419 92.6701 4.54419H1.02011V20.5119H72.5798L0 86.8108V89.8122C0 94.6008 3.67578 98.4873 8.20306 98.4873H102.138V82.3847H28.7992L100.865 15.9509H100.873Z"
            fill="#282828"
          />
          <path
            d="M120.406 13.2194V89.8037C120.406 94.5924 124.082 98.4789 128.61 98.4789H204.149V82.3763H138.423V58.2224H203.002V43.3254H138.423V20.5119H204.149V4.54419H128.61C124.082 4.54419 120.406 8.43073 120.406 13.2194Z"
            fill="#282828"
          />
          <path
            d="M222.839 13.2194V89.8037C222.839 94.5924 226.515 98.4789 231.042 98.4789H306.581V82.3763H240.856V58.2224H305.435V43.3254H240.856V20.5119H306.581V4.54419H231.042C226.515 4.54419 222.839 8.43073 222.839 13.2194Z"
            fill="#282828"
          />
          <path
            d="M343.28 4.54408H325.264V89.8036C325.264 94.5922 328.94 98.4788 333.467 98.4788H405.195V82.3762H343.28V4.53564V4.54408Z"
            fill="#282828"
          />
          <path
            d="M694.992 82.3762V4.53564H676.976V89.7952C676.976 94.5838 680.652 98.4704 685.179 98.4704H756.907V82.3678H694.992V82.3762Z"
            fill="#282828"
          />
          <path
            d="M553.323 22.1389C544.555 30.8731 535.964 40.8972 528.233 47.49C525.721 -5.8341 445.84 -13.7927 421.585 25.1824C412.421 39.8602 412.421 63.4409 421.585 78.1102C429.526 91.2115 443.159 98.5294 458.005 101.126C480.591 105.08 503.632 97.3238 519.853 81.12C528.629 72.3521 537.228 62.2943 544.968 55.7099C546.747 99.8445 600.492 111.032 631.838 95.8147C657.518 85.0487 665.94 48.8895 651.616 25.1065C644.197 12.6713 631.197 5.45459 616.958 2.57129C593.874 -2.10774 569.999 5.51361 553.314 22.1389H553.323ZM495.547 79.5013C478.5 89.4579 449.296 88.2018 437.704 69.7639C427.832 53.7203 433.565 28.6811 451.126 21.6584C467.793 14.2478 494.679 15.993 505.386 33.377C514.348 47.8019 510.579 71.3235 495.556 79.5013H495.547ZM635.513 69.8313C624.773 87.1142 597.904 88.9015 581.254 81.4825C563.667 74.4766 557.976 49.3532 567.832 33.377C578.741 15.8581 605.222 14.3068 622.024 21.6584C639.67 28.6053 645.394 53.8467 635.505 69.8313H635.513Z"
            fill="#cccccc"
          />
        </svg>
        <svg
          className="logo-main-path"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          x="0px"
          y="0px"
          viewBox="0 0 243.9 101.4"
          xmlSpace="preserve"
        >
          <g>
            <g>
              <path d="M96.2,77.9c4-5.3,6.4-11.7,7.5-18.2c0.8-4.8,1.3-9.8,1-14.7C104.1,35.5,100,26.5,93,20C85,12.6,74.2,9.1,63.5,8.1c-11.7-1-24.2,0.5-34.6,6.3c-8.5,4.7-15.1,12.3-18.4,21.5c-3.5,9.7-3.6,21,0.3,30.6c3.9,9.8,11.7,17.5,21.2,22c10,4.7,21.3,5.8,32.2,4.7c6.4-0.6,12.6-2.3,18.3-5.3c4.9-2.6,9.2-6.1,13.4-9.7c8.5-7.4,16.4-15.3,24.2-23.4c6.2-6.4,12.2-12.9,18.3-19.4c4.6-5,9.1-10,14.5-14.2c4.5-3.5,9.3-6.5,14.6-8.6c6.5-2.7,13.3-3.8,20.3-3.8c4.9,0,9.8,0.3,14.6,1.5c5.5,1.3,10.7,3.5,15.4,6.6c9,6,15.2,15.5,16.8,26.2c1.4,9.3-0.1,19.7-4.8,27.9c-4.9,8.5-13.1,14.1-22.1,17.4c-5.9,2.1-12,3.3-18.2,4c-5.5,0.6-11.1,0.4-16.5-0.9c-10.1-2.3-19.6-7.9-25.8-16.2c-6.7-8.9-8.8-20.1-6.7-31c1.3-6.6,4-12.9,7.4-18.7c0.3-0.6-0.5-1.1-0.9-0.5c-6.2,10.6-10,23-7.5,35.3c2,10,8.1,18.7,16.4,24.6c8.4,6,18.9,9,29.2,8.7c6.1-0.2,12.3-1.2,18.2-2.8c5.1-1.4,10.1-3.4,14.6-6.2c7.6-4.7,13.3-11.8,16.1-20.3c3-9.3,3.2-20.1-0.3-29.4c-3.7-9.9-11.4-17.7-20.9-22.2c-8.5-4.1-17.8-5.2-27.2-5c-7.7,0.2-15.1,2.1-22,5.5c-5.3,2.7-10.2,6.1-14.6,10c-4.5,3.9-8.3,8.4-12.4,12.7c-6.5,7-13,13.9-19.6,20.8c-7.7,7.9-15.5,15.7-24,22.7c-4.9,4.1-10.1,7.6-16.1,9.8c-5.6,2.1-11.5,3-17.5,3.1c-5.7,0.1-11.3-0.1-16.8-1.5c-5.5-1.3-10.8-3.5-15.5-6.6c-9-6-15.4-15.3-17.3-26c-1.8-10.1,0.1-21.1,5.6-29.8c5.6-8.9,14.7-14.7,24.7-17.5c6.1-1.7,12.4-2.3,18.7-2.2c6.2,0.1,12.5,1,18.4,3C86.5,15,95,21.3,99.7,30.4c4.6,8.9,4.7,19.2,3,28.9c-1.1,6.5-3.4,12.8-7.4,18.1C94.9,77.9,95.8,78.4,96.2,77.9L96.2,77.9z" />
            </g>
          </g>
        </svg>
      </Box>
    </Box>
  );
};

// 默认导出 Loading 组件
export default Loading;
